package core.extensions

import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Job
import kotlinx.coroutines.cancel
import react.useEffectOnce

/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 24.11.22
 * Author : marcusspors
 */


/**
 * Only works inside [fc]
 * @see <a href="https://reactjs.org/docs/hooks-state.html#hooks-and-function-components">Hooks and Function Components</a>
 */
fun useCoroutineScope(): CoroutineScope {
    val scope = CoroutineScope(Job())
    useEffectOnce {
        cleanup { scope.cancel() }
    }
    return scope
}
